module.exports = __webpack_public_path__ + "static/media/criteria-9.1.1eaec0bc.jpg";